import { message } from "antd";
import { useRequest } from "ahooks";
import { createContext, useCallback, useContext } from "react";

import { ResponseCode } from "../constants";
import { getAllPlanService } from "../service";
import {
  transformPlanResponseToVersionWithPriceMap,
  transformVersionWithPriceMapToArray,
} from "../utils";
import { IVersionWithPrice, VersionWithPriceMapType } from "../types";

const PriceContext = createContext<{
  useVersionWithPrice: () => {
    map: VersionWithPriceMapType;
    array: IVersionWithPrice[];
  };
}>({
  useVersionWithPrice: () => {
    return {
      map: {} as VersionWithPriceMapType,
      array: [] as IVersionWithPrice[],
    };
  },
});

/**
 * 调用钩子
 * @returns
 */
export const useVersionWithPrice = () => {
  const { useVersionWithPrice: dispatcher } = useContext(PriceContext);
  return dispatcher!();
};

/**
 * 价格上下文 provider
 * @returns
 */
export const VersionWithPriceContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { data } = useRequest(async () => {
    const rsp = await getAllPlanService();

    if (rsp.code !== ResponseCode.Success) {
      message.error(rsp.msg);

      return {
        map: {} as VersionWithPriceMapType,
        array: [] as IVersionWithPrice[],
      };
    }

    const map = transformPlanResponseToVersionWithPriceMap(rsp.data);
    const array = transformVersionWithPriceMapToArray(map);

    return {
      map,
      array,
    };
  });

  const useVersionWithPriceDispatcher = useCallback(() => {
    return (
      data ?? {
        map: {} as VersionWithPriceMapType,
        array: [] as IVersionWithPrice[],
      }
    );
  }, [data]);

  return (
    <PriceContext.Provider
      value={{ useVersionWithPrice: useVersionWithPriceDispatcher }}
    >
      {children}
    </PriceContext.Provider>
  );
};
